import { RootState } from '../types/rootstate'

export const showConsentSelector = (state: RootState) => state.consent.showConsent
export const shouldShowConsentSelector = (state: RootState) => !state.consent.hasShownConsent
export const consentStatusSelector = (state: RootState) => state.consent.status
